import { getCookie } from './utils/trainUtils';
import { MMT_AUTH } from './constants/TrainConstants';

const mmtAuth = getCookie(MMT_AUTH);
const configAd = {
  userCallbackForView(id, adResponse) {
    console.log('view callback');
  },

  userClickHandlerForClick(id, adResponse) {
    console.log('click callback');
  },

  onError(error, id) {
    console.log('error callback');
  },

  ORG: 'MMT',
  AUTH_COOKIE_KEY: mmtAuth || 'mmt-auth',
  mode: 'PROD',
  API_CALL: 'SINGLE',
};

export default configAd;
